import React from 'react';
import './ProgressBar.pcss';

type Props = {
  caption?: string;
  progress: number;
};
export const ProgressBar = (props: Props) => {
  const { progress, caption } = props;
  return (
    <div className="c-progress-bar">
      {caption && <div className="c-progress-bar__caption">{caption}</div>}
      <div className="c-progress-bar__bar">
        <div
          className="c-progress-bar__bar-completed"
          style={{ width: `${progress * 100}%` }}
        />
      </div>
    </div>
  );
};
